// src/utils/formatters.js
export const formatAddress = (address) => {
  if (!address) return "";
  return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
};

export const formatBalance = (balance, decimals = 4) => {
  if (!balance) return "0";
  const floatValue = parseFloat(balance);
  return floatValue.toFixed(decimals);
};

export const formatPercentage = (value, decimals = 2) => {
  if (!value) return "0.00";
  const floatValue = parseFloat(value);
  return (floatValue / 100).toFixed(decimals);
};